import React from 'react';
import { usePagination } from './pagination.hooks';
import {
  ArrowPath,
  PaginationArrow,
  PaginationArrowBack,
  Wrapper,
} from './pagination.styles';

interface PaginationProps {
  pageSize: number;
  totalCount: number;
  activePage: number;
  relatedParams: any;
  onPageChange: (pageIndex: number) => void;
}

const Pagination = ({
  pageSize,
  totalCount,
  onPageChange,
  activePage,
  relatedParams,
}: PaginationProps): JSX.Element => {
  const {
    paginationRef,
    clickBackPageHandler,
    pages,
    clickNextPageHandler,
    pagesLength,
  } = usePagination({
    pageSize,
    totalCount,
    onPageChange,
    activePage,
    relatedParams,
  });

  return (
    <Wrapper ref={paginationRef}>
      <PaginationArrowBack onClick={clickBackPageHandler}>
        <svg
          width="22"
          height="12"
          viewBox="0 0 22 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ArrowPath
            isActive={activePage > 1}
            d="M20.25 6H1.75M1.75 6L6.75 1M1.75 6L6.75 11"
            stroke="#D8DFE4"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </PaginationArrowBack>
      {pages}
      <PaginationArrow onClick={clickNextPageHandler}>
        <svg
          width="22"
          height="12"
          viewBox="0 0 22 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ArrowPath
            isActive={activePage < pagesLength}
            d="M1.75 6L20.25 6M20.25 6L15.25 11M20.25 6L15.25 1"
            stroke="#D8DFE4"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </PaginationArrow>
    </Wrapper>
  );
};

export default Pagination;
